/**
 * admin/query-keys — TanStack Query key factory for the back-office panels.
 *
 * Same contract as `utils/query-keys.ts`: never inline string arrays at the call
 * site, always go through this factory so invalidation prefixes stay consistent
 * across the admin features (users, audit, integrations, flags, metrics).
 /** Waits for the app to finish booting (skeleton overlay disappears). */

export interface AdminUsersFilter {
  q?: string;
  role?: string;
  page?: number;
}

export interface AdminAuditFilter {
  entityType?: string;
  action?: string;
  userId?: string;
  page?: number;
}

export const adminQueryKeys = {
  all: ["admin"] as const,
  users: (filter: AdminUsersFilter = {}) => ["admin", "users", filter] as const,
  audit: (filter: AdminAuditFilter = {}) => ["admin", "audit", filter] as const,
  integrations: () => ["admin", "integrations"] as const,
  flags: () => ["admin", "flags"] as const,
  metrics: () => ["admin", "metrics"] as const,
  maintenance: () => ["admin", "maintenance"] as const,
};
